/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class PencilRuler extends React.Component {
  render() {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64'>
		    <path fill='none' stroke='#f66164' strokeMiterlimit='10' strokeWidth='2' d='M1 63V2l61 61z' />
		    <path fill='none' stroke='#f66164' strokeMiterlimit='10' strokeWidth='2' d='M14 54V30l24 24zM8 22H2M6 30H2M8 38H2M6 46H2M8 54H2M25 1l-6 6 36 36 8 2-2-8zM25 13l6-6'
		    />
			</svg>
    );
  }
}

export default PencilRuler;



// WEBPACK FOOTER //
// ./src/routes/home/img/icons/PencilRuler.js